<app-comparison-html-template [recDataSource]="recDataSource" [lcaDataSource]="lcaDataSource"
  [analysesDataLoaded]="analysesDataLoaded" [recTableData]="recTableData" [lcaTableData]="lcaTableData"
  [newLcaAllowed]="newLcaAllowed" [volumeAvailable]="volumeAvailable" [weightAvailable]="weightAvailable"
  (createRecAnalysis)="createNewRecyclabilityAnalysis($event)" (createLcaAnalysis)="createNewLifecycleAnalysis($event)">
</app-comparison-html-template>